import Table from "Shared/components/DataTable/Table"
import restClient from 'Shared/hooks/restClient'
import PinnedBookmarks from "Shared/components/PinnedBookmarks/PinnedBookmarks"

const DashboardsDatatable = ({ tableType }) => {
  const handleTableClick = (e) => {
    const button = e.target.closest('button')
    if (button && button.classList.contains('toggle-bookmark')) {
      restClient
        .post('/api/user_bookmarks/toggle', { entity_type: 'Dashboard', entity_id: button.dataset.id })
        .then(() => {
          window.dispatchEvent(new CustomEvent('bookmarks-changed', { detail: { entityType: 'Dashboard' } }))
        })
      return
    }
    if (button && button.classList.contains('restore-dashboard')) {
      const dashboardId = button.dataset.dashboardId

      if (window.confirm('Are you sure you want to restore this dashboard?')) {
        restClient.post(`/api/dashboards/${dashboardId}/restore`).then(() => {
          window.location.href = '/admin/dashboards'
        })
      }
    }
  }

  const emptyTableMessage = tableType === 'all' ? "You've not set up any dashboards yet." : "You have no archived dashboards."

  const tableProps = {
    table: 'dashboards',
    scope: { section: 'dashboards' },
    language: { emptyTable: emptyTableMessage },
    includeTypeParam: true,
    onClick: handleTableClick,
  }

  const reloadTable = () => {
    window.$('table').DataTable().ajax.reload(null, false)
  }

  useEffect(() => {
    const handler = (e) => {
      if (e.detail?.entityType === 'Dashboard') reloadTable()
    }
    window.addEventListener('bookmarks-changed', handler)
    return () => window.removeEventListener('bookmarks-changed', handler)
  }, [])

  return (
    <div className="section">
      <PinnedBookmarks entityType="Dashboard" />

      <div className="box">
        <div className="header">
          <h2>Your dashboards</h2>
        </div>

        <Table {...tableProps} />
      </div>
    </div>
  )
}

export default DashboardsDatatable
